import { render, staticRenderFns } from "./ContactBlock.vue?vue&type=template&id=1aec357b&scoped=true&"
import script from "./ContactBlock.vue?vue&type=script&lang=ts&"
export * from "./ContactBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ContactBlock.vue?vue&type=style&index=0&id=1aec357b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aec357b",
  null
  
)

export default component.exports